import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PageOptions } from 'typings/pagination'

const initialState: PageOptions[] = []

const selectedPageSlices = createSlice({
  name: 'selectedPageNumber',
  initialState,
  reducers: {
    selectPageNumber(state, action: PayloadAction<PageOptions>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    resetAllPageNumbers(state) {
      return state.map((item) => ({
        ...item,
        pageNumber: 1,
      }))
    },
  },
})

export const { selectPageNumber, resetAllPageNumbers } = selectedPageSlices.actions

export default selectedPageSlices.reducer
